import { render, staticRenderFns } from "./InquiryListItem.vue?vue&type=template&id=118c0725&scoped=true"
import script from "./InquiryListItem.vue?vue&type=script&lang=js"
export * from "./InquiryListItem.vue?vue&type=script&lang=js"
import style0 from "./InquiryListItem.vue?vue&type=style&index=0&id=118c0725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c0725",
  null
  
)

export default component.exports